import { render } from "./Disinfect.vue?vue&type=template&id=955d8284&scoped=true"
import script from "./Disinfect.vue?vue&type=script&lang=js"
export * from "./Disinfect.vue?vue&type=script&lang=js"

import "./Disinfect.vue?vue&type=style&index=0&id=955d8284&lang=scss"
import "./Disinfect.vue?vue&type=style&index=1&id=955d8284&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-955d8284"

export default script